<svg class="spinner">
  <circle
    [class.spinner__circle--animate]="animate()"
    class="spinner__circle"
    cx="20"
    cy="20"
    r="18"
  />
</svg>
